const SKELETON_IDS = ["sk-1", "sk-2", "sk-3", "sk-4", "sk-5", "sk-6"];

function ResultsSkeleton() {
  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(200px,1fr))] gap-4">
      {SKELETON_IDS.map((id) => (
        <div key={id} className="overflow-hidden rounded-md bg-surface">
          <div className="animate-shimmer aspect-[16/10]" />
          <div className="flex flex-col gap-2.5 p-4">
            <div className="animate-shimmer h-3 w-[70%] rounded-md" />
            <div className="animate-shimmer h-3 w-[40%] rounded-md" />
            <div className="animate-shimmer h-3 w-[55%] rounded-md" />
          </div>
        </div>
      ))}
    </div>
  );
}

export { ResultsSkeleton };
